/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2fa_Confirm_ActionInputs */

const cs_settings_profile_2fa_confirm_action = /** @type {(inputs: Settings_Profile_2fa_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdit`)
};

const en_settings_profile_2fa_confirm_action = /** @type {(inputs: Settings_Profile_2fa_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Settings_Profile_2fa_Confirm_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa_confirm_action = /** @type {((inputs?: Settings_Profile_2fa_Confirm_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2fa_Confirm_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa_confirm_action(inputs)
	return cs_settings_profile_2fa_confirm_action(inputs)
});